import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EntryPage from './EntryPage';
import AdminPage from './AdminPage';
import FencerPage from './FencerPage';
import AdminCompetition from './AdminCompetition';
import SignupsDisplay from './SignupsDisplay';
// import Register from './Register';
// import Success from './Success';
// import Cancel from './Cancel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EntryPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/fencer" element={<FencerPage />} />
        <Route path="/admin/competition/:id" element={<AdminCompetition />} />
        <Route path="/signupsdisplay" element={<SignupsDisplay />} /> 
      {/*  <Route path="/register" element={<Register />} /> 
        <Route path="/success" element={<Success />} /> 
        <Route path="/cancel" element={<Cancel />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
